export default "__VITE_ASSET__BgObDpdI__"